import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

export const useMarkMedicationExtractionAsErroneous = ({
  patientId,
  amazonVisitId,
}: {
  patientId?: string;
  amazonVisitId?: string;
} = {}) => {
  const queryClient = useQueryClient();

  return useApiMutation<void, { questionnaireResponseId: string }>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.AmazonVisitIntake
          .MARK_MEDICATION_EXTRACTION_AS_ERRONEOUS,
      mutationFn: async ({
        questionnaireResponseId,
      }: {
        questionnaireResponseId: string;
      }) => {
        await axiosInstance.put(
          `amazon-clinic/medication-extractions/${questionnaireResponseId}/marked-as-erroneous`,
        );
      },
      onSuccess: () => {
        if (patientId && amazonVisitId) {
          queryClient.invalidateQueries({
            queryKey: QueryKeys.Patient.Chart.AmazonVisitIntake.DEFAULT({
              patientId,
              amazonVisitId,
            }),
          });
        }
      },
    },
  });
};
